export const COURSE_INTRO_FALLBACK =
  "Willkommen! In diesem Kurs erwartet dich ein strukturierter Lernweg durch die zentralen Inhalte. Nimm dir Zeit, arbeite die Module in deinem Tempo durch und nutze die Begleitmaterialien, um das Gelernte zu vertiefen.";

export const MODULE_INTRO_FALLBACK =
  "In diesem Modul lernst du die zentralen Inhalte dieses Abschnitts kennen. Die einzelnen Kapitel bauen aufeinander auf und führen dich Schritt für Schritt zum Modulziel.";

export const CHAPTER_INTRO_FALLBACK =
  "In diesem Kapitel vertiefst du die Inhalte aus den vorangegangenen Abschnitten und erweiterst dein Verständnis um die konkreten Themen dieses Kapitels.";

export const CHAPTER_OUTRO_FALLBACK =
  "Du hast dieses Kapitel abgeschlossen. Gönn dir einen kurzen Moment zum Reflektieren, und wenn du bereit bist, geht es weiter mit dem nächsten Abschnitt.";

export const MODULE_OUTRO_FALLBACK =
  "Du hast dieses Modul abgeschlossen. Du hast die zentralen Inhalte dieses Abschnitts erarbeitet – wenn du bereit bist, geht es weiter mit dem nächsten Modul.";
